/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfo_shipment$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailShipping_shipment$ref: FragmentReference;
export type PdpSharedDetailShipping_shipment = {|
  +$fragmentRefs: PdpSharedShippingInfo_shipment$ref,
  +$refType: PdpSharedDetailShipping_shipment$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e9f3329434df464231cc9695b4dad2f4';
module.exports = node;
